import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconDropDownMediumArrow = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.40971 5.89134L11.0823 1.30422C11.1904 1.19813 11.25 1.0565 11.25 0.905489C11.25 0.754477 11.1904 0.61285 11.0823 0.506756L10.7382 0.168946C10.5141 -0.0508683 10.1497 -0.0508683 9.9259 0.168946L6.00218 4.02086L2.0741 0.164672C1.96594 0.0585778 1.82176 -4.07967e-07 1.66802 -4.1462e-07C1.5141 -4.2128e-07 1.36992 0.0585777 1.26168 0.164672L0.917743 0.502481C0.809585 0.608659 0.75 0.750202 0.75 0.901215C0.75 1.05223 0.809585 1.19385 0.917743 1.29995L5.59456 5.89134C5.70306 5.99768 5.84792 6.05609 6.00192 6.05576C6.15652 6.05609 6.3013 5.99768 6.40971 5.89134Z"
                fill={color}
            />
        </svg>


    </div>
);

export default IconDropDownMediumArrow;
